import React from "react";
import "./Box.scss";

export const Box = (props) => {
  return <div className={`box-type ${props.objectType}`}></div>;
};
